module.exports = __webpack_public_path__ + "static/media/banner_compendio_completo_.4b173df0.jpg";